<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .cards {
    display: grid;
    gap: utils.in_rem(12px);

    &.is-overlay {
      grid-template-columns: repeat(3, 1fr);
      @media (max-width: 970px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 740px) {
        grid-template-columns: repeat(1, 1fr);
      }
    }

    &:not(.is-overlay) {
      grid-template-columns: repeat(2, 1fr);
      padding-right: utils.in_rem(12px); // keep away from scrollbar
    }
  }

  a {
    color: colors.get(primary_50);
  }
</style>

<script>
  import CompanyInsightsContainer from "../CompanyInsightsContainer.svelte";
  import Filter from "../Filter.svelte";
  import ShowMoreButton from "../ShowMoreButton.svelte";
  import {
    companyInsightsOptsStore,
    companyInsightsStore,
    isOverlayStore,
    newsTagsStore,
  } from "../stores";
  import { showItem } from "../utils";
  import NewsArticleCard from "./NewsArticleCard.svelte";

  // For tag filter
  let selectedItems = [];
  let showFilter = false;

  const searchQuery =
    $companyInsightsStore?.name || $companyInsightsOptsStore.opts?.company;
  const googleNewsLink = searchQuery
    ? `https://news.google.com/search?q=${searchQuery}`
    : "https://news.google.com";

  $: showEmptyState =
    !$companyInsightsStore?.news || $companyInsightsStore?.news.length === 0;

  $: disabled = !$newsTagsStore || $newsTagsStore.length === 0;

  let showingAllItems = false;

  let innerWidth = 0;

  // Shows one row, regardless of screen size
  $: maxItems = innerWidth < 740 ? 1 : innerWidth < 970 ? 2 : 3;

  $: wrappedNews =
    showingAllItems || !$isOverlayStore
      ? $companyInsightsStore?.news
      : $companyInsightsStore?.news?.slice(0, maxItems);
</script>

<svelte:window bind:innerWidth />

<!-- Don't render the filter on the overlay if there are no tags -->
{#if !$isOverlayStore || !disabled}
  <Filter
    items={$newsTagsStore}
    bind:selectedItems
    bind:show={showFilter}
    {disabled}
  />
{/if}

<CompanyInsightsContainer {showEmptyState} {showFilter}>
  <div class="cards" class:is-overlay={$isOverlayStore}>
    {#each wrappedNews as article}
      {#if showItem(article, selectedItems)}
        <NewsArticleCard {article} />
      {/if}
    {/each}
  </div>
  {#if $isOverlayStore && $companyInsightsStore?.news.length > maxItems}
    <ShowMoreButton bind:showingMore={showingAllItems} />
  {/if}
  <span slot="noCompanyInfo"> No news articles found </span>
  <span slot="noCompanyInfoSubtext">
    We recommend searching <strong
      ><a href={googleNewsLink}>Google News</a></strong
    > for recent articles
  </span>
</CompanyInsightsContainer>
